import './plugins'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import VueCountdown from '@chenfengyuan/vue-countdown';
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'
import Widget from './components/Widget.vue';
import '@mdi/font/css/materialdesignicons.css'
import VueExcelXlsx from "vue-excel-xlsx";

Vue.component(VueCountdown.name, VueCountdown);
Vue.component('widget',Widget);

Vue.use(Viewer)
Vue.use(Chartkick.use(Chart))
Vue.use(VueExcelXlsx);

Vue.config.productionTip = false
console.log(`%c${process.env.VUE_APP_NAME}`, "color: red; font-size: x-large");
console.log(`%c${process.env.NODE_ENV}`, "background: white; color: blue; font-size: large");

Vue.prototype.$eventHub = new Vue();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
